<template>
    <div>
        <ValidationObserver ref="documentForm">
        <fieldset class="border p-3 mb-4 rounded bg-white shadow-sm" v-if="requiredDocuments && requiredDocuments.length>0">
            <legend class="w-auto px-2 font-weight-bold h6">{{ $t('documents') }}</legend>
            <b-table-simple hover small responsive class="border rounded text-center">
                <b-thead head-variant="light">
                    <b-tr>
                        <b-th class="text-left font-weight-bold">{{$t('document_type')}}</b-th>
                        <b-th class="font-weight-bold">{{ $t('status') }}</b-th>
                        <b-th style="width: 300px;" class="font-weight-bold">{{$t('status')}}</b-th>
                        <b-th  class="font-weight-bold">{{$t('action')}}</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(doc, index) in requiredDocuments" :key="index">
                        <b-td class="align-middle text-left font-weight-bold">
                            {{ getLocaleText(doc, 'name') }}
                        </b-td>
                        <b-td class="align-middle">
                            <div class="d-flex flex-column justify-content-center align-item-center">
                                <b-badge :variant="['approved','uploaded'].includes(doc.status) ? 'success' :(doc.status==='declined'?'danger':'secondary')">
                                    {{ doc.status === 'uploaded' ? $t('status_uploaded') : (doc.status==='declined'?$t('status_declined'):(doc.status==='approved' ? $t('approved'):$t('status_waiting'))) }}
                                </b-badge>
                                <div v-if="formData.documents[doc.code]" class="small mt-1 text-success font-weight-bold">
                                    <i class="ri-check-line"></i> {{ $t('was_elected') }}

                                </div>
                                <b-button
                                    v-if="['uploaded','approved'].includes(doc.status)"
                                    size="sm"
                                    variant="outline-primary"
                                    @click="downloadDocument(doc)"
                                    class="mt-2"
                                    :title="$t('download')"
                                >
                                    <i class="ri-download-cloud-2-line mr-1"></i> {{$t('download')}}
                                </b-button>
                            </div>

                        </b-td>
                        <b-td class="align-middle text-center" v-if="doc.status!=='approved'">
                                <ValidationProvider :ref="'provider_' + index" :name="$t(doc.code)" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('file')">
                                        <div class="d-flex custom-file-upload">
                                            <b-form-file
                                                v-model="formData.documents[doc.code]"
                                                accept=".pdf,.doc,.docx"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                :placeholder="$t('select_file')"
                                                :drop-placeholder="$t('drop_file')"
                                                :ref="'fileInput_' + index"
                                            ></b-form-file>
                                            <b-button variant="outline-secondary"
                                                      @click="$refs['fileInput_' + index][0].$el.childNodes[0].click();">
                                                {{ $t('browse') }}
                                            </b-button>
                                        </div>
                                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                    </b-form-group>
                                </ValidationProvider>
                        </b-td>
                        <b-td v-else>

                        </b-td>
                        <b-td class="align-middle text-center" v-if="doc.status!=='approved'">
                            <div class="d-flex align-items-center justify-content-center">
                                <b-button variant="primary" @click="sendForm(doc,index)">{{$t('save')}}</b-button>
                            </div>
                        </b-td>
                        <b-td v-else>

                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </fieldset>
            <div class="d-flex align-items-center justify-content-center" v-if="checkPermission('internshipapplication_sendapprove')">
                <b-button variant="primary" @click="goApproved()">{{$t('approved_go')}}</b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>

import {ValidationObserver, ValidationProvider} from "vee-validate"
import internshipApplicationService from "@/services/InternshipApplicationService";
export default {
    props: {
        formId: {
            type: Number,
        },
        documents:{
            type:Array,
            default:()=>[]
        },
        studentProgramId:{
            type:Number,
            default:0
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            formData:{
                documents: {}
            },
            selectedFile: null,
            requiredDocuments: []
        }
    },
    methods: {
        downloadDocument(document) {
            const data = {
                internship_application_id: this.formId,
                type: document.code,
                student_program_id: this.student_program_id,
            }
            internshipApplicationService.showDocuments(data)
                .then(res => {
                    this._downloadFile(res, document.name + '.' + (res.headers.file_extension ?? 'pdf'))

                }).catch((err) => {
                this.showErrors(err, null)
            })
        },
       async setDocuments(studentDocumentsData){
            await this.$store.dispatch("fetchParameter", {
                    parameterCode: "internship_application.documents" ,
                }
            );
            const documents=this.$store.getters.getParameter('internship_application.documents')
            let selectedDocuments =[]
            if (documents.items && documents.items.length>0){
                documents.items.forEach(item=>{
                    studentDocumentsData.forEach(doc=>{
                        if (item.code===doc.type){
                            selectedDocuments.push({
                                code:doc.type,
                                status:doc.status,
                                name:item.name
                            })
                        }
                    })
                })
            }

            this.requiredDocuments=selectedDocuments
            if (this.requiredDocuments && this.requiredDocuments.length>0){
                this.requiredDocuments.forEach((item)=>{
                    if (!this.formData.documents[item.code]){
                        this.$set(this.formData.documents, item.code, null)
                    }
                })
            }
        },
        async sendForm(doc,index){
            const provider =this.$refs['provider_' + index][0]
            const result = await provider.validate()
            if (!result.valid)return
            const formData = new FormData()
            formData.append('internship_application_id', this.formId)
            formData.append('student_program_id', this.studentProgramId)
            formData.append('type', doc.code)
            formData.append('file', this.formData.documents[doc.code])
            internshipApplicationService.uploadInternshipApplicationFile(formData).then(response => {
                this.$toast.success(this.$t('upload_file') +  ' '+this.$t('success'));
                this.setDocuments(response.data.data)
                this.formData.documents[doc.code] = null
                provider.reset()
            }).catch(error => {
                this.showErrors(error,this.$refs['provider_' + index][0])
            })
        },
        async goApproved(){
            try {
                await  internshipApplicationService.goApprove({internship_application_id:this.formId})
                this.$toast.success(this.$t('proccess_success'));
                this.$emit('processed',true)
            }catch (err){
                this.showErrors(err)
            }
        }
    },
    created() {
        this.setDocuments(this.documents)
    },
}
</script>
